import {createSlice} from "@reduxjs/toolkit";

const initialQualityState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  qualityForEdit: undefined,
  lastError: null,
  locations: null,
  locationsTotalCount: 0
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const qualitySlice = createSlice({
  name: "quality",
  initialState: initialQualityState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findQuality
    qualityFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.qualityForEdit = null;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    qualityForEditFetched: (state, action) => {
      const { qualityForEdit } = action.payload;
      state.qualityForEdit = qualityForEdit;
    },
    //findLocations
    locationsFetched: (state, action) => {
      const { locationsTotalCount, locations } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.locations = locations;
      state.locationsTotalCount = locationsTotalCount;
    },
    // createQuality
    qualityCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.qualityForEdit = action.payload.quality;
      state.entities.push(action.payload.quality);
    },
    // updateQuality
    qualityUpdated: (state, action) => {
      state.error = null;
      state.qualityForEdit = null;
      state.actionsLoading = false;
      state.entities = [...state.entities, ...(action.payload.qualityArray)]
    },
    // deleteQuality
    qualityDeleted: (state, action) => {
      state.error = null;
      state.qualityForEdit = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // qualityUpdateState
    qualityStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
